import storage from '../../../../hooks/useStorage/useStorage';
import { OrderBookOrder } from '../../../../stores/OrderBook/orderBook.types';

export const getSavedProductDetailsPreferences = () =>
  storage.getProductDetailsFilter(storage.getSessionId() as string);

export const resolvePreferredProductColorId = (productColorId?: string) =>
  getSavedProductDetailsPreferences().applyAllColors ? undefined : productColorId;

interface ResolveProductDetailsOrderIdsParams {
  shouldApplyAllOrders?: boolean;
  allOrders: OrderBookOrder[];
  selectedOrderId?: string;
}

export const resolveProductDetailsOrderIds = ({
  shouldApplyAllOrders,
  allOrders,
  selectedOrderId,
}: ResolveProductDetailsOrderIdsParams) => {
  if (shouldApplyAllOrders) {
    return allOrders.map((order: OrderBookOrder) => order.id);
  }

  return selectedOrderId ? [selectedOrderId] : [];
};
